import { render, staticRenderFns } from "./AuditLogsPage.vue?vue&type=template&id=fd3c6768&scoped=true&"
import script from "./AuditLogsPage.vue?vue&type=script&lang=js&"
export * from "./AuditLogsPage.vue?vue&type=script&lang=js&"
import style0 from "./AuditLogsPage.vue?vue&type=style&index=0&id=fd3c6768&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd3c6768",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\DigitalCreditTransfer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fd3c6768')) {
      api.createRecord('fd3c6768', component.options)
    } else {
      api.reload('fd3c6768', component.options)
    }
    module.hot.accept("./AuditLogsPage.vue?vue&type=template&id=fd3c6768&scoped=true&", function () {
      api.rerender('fd3c6768', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/administration/AuditLogsPage.vue"
export default component.exports